import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { styled } from 'linaria/react';
import React from 'react';
import UIMaxWidth from '../Layout/MaxWidth';
import DynamicPageContentRenderer from '../../r3-lib/components/layout/DynamicPageRenderer/DynamicPageRenderer';

import { css } from 'linaria';
import { allContentComponents } from '../ContentComponents/ContentComponents';
import { StyledBreadcrumbs } from '../ui/StyledBreadcrumbs';
import { theme } from '../Theme';

const Content = styled('div')`
  padding-bottom: 1rem;

  p {
    margin-bottom: 1rem;
  }
`;

const container = css`
  display: flex;
  width: 100%;
  max-width: 78rem;
  /* padding-top: 60px; */
  ${theme.below.lg} {
    padding: 0 20px;
  }
`;

const BreadcrumbsWrapper = styled('div')`
  max-width: 78rem;
  width: 100%;
  margin: auto;
  padding: 32px 32px 0 32px;

  ${theme.below.lg} {
    padding: 40px 20px 0 20px;
  }
`;

function ContentPage({ page, result }) {
  const isHero = page?.data?.items[0]?.type === 'Hero';

  return (
    <>
      <div>
        {isHero ? null : (
          <BreadcrumbsWrapper>
            <StyledBreadcrumbs
              parents={result.data?.route?.parents}
              breadcrumbs={result.data?.route?.breadcrumbs}
            />
            <h1>{page?.name}</h1>
          </BreadcrumbsWrapper>
        )}
        {page ? (
          page?.data?.items?.length > 0 ? (
            <UIMaxWidth className={container}>
              <DynamicPageContentRenderer
                pageId={page?.id}
                rendererComponents={allContentComponents}
              />
            </UIMaxWidth>
          ) : (
            <UIMaxWidth className={container}>
              <Content dangerouslySetInnerHTML={{ __html: page.content }} />
            </UIMaxWidth>
          )
        ) : (
          <LoadingLine
            heightPx={14}
            widthRem={30}
            randomizeWidthBy={10}
            count={10}
            style={{
              marginBottom: '12px'
            }}
          />
        )}
      </div>
    </>
  );
}

export default ContentPage;
